var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, Injector } from '@angular/core';
import { NameValueOfString, PriorityType } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
var PriorityTypesMultiSelectComponent = /** @class */ (function (_super) {
    __extends(PriorityTypesMultiSelectComponent, _super);
    function PriorityTypesMultiSelectComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this._exclude = [];
        _this.name = 'PriorityTypeFilter';
        _this.selectedItemsChange = new EventEmitter();
        _this.priorityTypeValues = PriorityType;
        _this.options = new Array();
        _this._selectedItems = [];
        _this.placeholder = _this.l('Priority');
        return _this;
    }
    Object.defineProperty(PriorityTypesMultiSelectComponent.prototype, "selectedItems", {
        get: function () {
            return this._selectedItems;
        },
        set: function (items) {
            this._selectedItems = items || [];
            this.selectedItemsChange.emit(this._selectedItems);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(PriorityTypesMultiSelectComponent.prototype, "exclude", {
        set: function (exclude) {
            this._exclude = exclude;
            this.setPriorityTypes();
        },
        enumerable: true,
        configurable: true
    });
    PriorityTypesMultiSelectComponent.prototype.ngOnInit = function () {
        this.setPriorityTypes();
    };
    PriorityTypesMultiSelectComponent.prototype.priorityTypeKeys = function () {
        var keys = Object.keys(this.priorityTypeValues);
        return keys.slice(keys.length / 2);
    };
    PriorityTypesMultiSelectComponent.prototype.setPriorityTypes = function () {
        var _this = this;
        this.options = [];
        this.priorityTypeKeys().forEach(function (e) {
            if (!_this._exclude.includes(e)) {
                _this.options.push(new NameValueOfString({ name: _this.l(e), value: _this.priorityTypeValues[e] }));
            }
        });
    };
    PriorityTypesMultiSelectComponent.prototype.onPanelHide = function () {
        document.getElementById(this.name).focus();
    };
    return PriorityTypesMultiSelectComponent;
}(AppComponentBase));
export { PriorityTypesMultiSelectComponent };
